import React from "react";

export default function ActiveStatusFilter({ value, onChange, label = "Record status" }) {
  return (
    <div className="flex justify-end mb-4">
      <div className="inline-flex rounded-xl border border-slate-300 bg-slate-50 p-1" role="group" aria-label={label}>
        {[true, false].map((isActive) => {
          const text = isActive ? "Active" : "Inactive";
          const selected = value === isActive;
          return <button key={text} type="button" aria-pressed={selected} onClick={() => onChange(isActive)} className={`rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${selected ? "bg-slate-900 text-white shadow-sm" : "text-slate-600 hover:bg-white hover:text-slate-900"}`}>{text}</button>;
        })}
      </div>
    </div>
  );
}
